module.exports = __webpack_public_path__ + "img/signs16.a21830cd.jpg";